export default function(type) {
    switch (type) {
      case "NotbusinessDay":
        return "Apertura en día no hábil";
      case "NotbusinessTime":
        return "Apertura fuera del horario laboral"
      default:
        return type;
    }
  }